import { GetSqlVmNetworkInfoApi, type Configuration } from '@repo/api-gw-sdk';

import type { HttpClient } from './httpClient';

const baseUrl = '/azure';

export const azure = (
  httpClient: HttpClient,
  config: Configuration,
  currentProjectId: string
) => {
  const getSqlVmNetworkInfoApi = new GetSqlVmNetworkInfoApi(config);

  return {
    useSqlVmNetworkInfo: (params: {
      cloudAccountId: string;
      resourceGroup: string;
      vmName: string;
    }) => {
      const enabled = Boolean(
        params.cloudAccountId && params.resourceGroup && params.vmName
      );
      return httpClient.execute(
        getSqlVmNetworkInfoApi.getSqlVmNetworkInfo.bind(getSqlVmNetworkInfoApi),
        enabled ? baseUrl : null,
        'getSqlVmNetworkInfo',
        currentProjectId,
        {
          cloudAccountId: params.cloudAccountId,
          resourceGroup: params.resourceGroup,
          vmName: params.vmName,
        }
      );
    },
  };
};
